
import { Announcements, CreateServiceRequestData, HoldBooking, SendAnnouncementOptions, Comment, ToDo, UpdateServiceRequestData, UserCredentials, Violation, ViolationStatus, VisitorParkingRequest, VisitorParkingRequestStatus, CalendarEvent } from '../Types/UnitFeatureTypes';
import { BACKEND_SERVER_URL } from './Constants';


export const userSignIn = async ({
    email,
    password
  }: UserCredentials): Promise<any> => {
    const response = await fetch(`${BACKEND_SERVER_URL}/user/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });
  
    if (response.status === 200) {
      return await response.json();
    } else {
      return { error: "InvalidCredentials" };
    }
  };  

export const verifyToken = async (token: string): Promise<any | false> => {
    const response = await fetch(`${BACKEND_SERVER_URL}/user/verify`, {
        method: 'GET',
        headers: { 'Authorization': `Bearer ${token}` },
    });

    return response.status === 200 ? response.json() : false;
}; 

export const createServiceRequest = async (data: CreateServiceRequestData): Promise<any> => {
    const userToken = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createServiceRequest`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${userToken}`

        },
        body: JSON.stringify(data)
    });
    
    return response.json();
};

export const fetchServiceRequestById = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getServiceRequestById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchAllServiceRequest = async (offset: number, sortColumn: string, sortDirection: string ): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllServiceRequests?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const editServiceRequest = async (data: UpdateServiceRequestData, id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateServiceRequest?id=${id}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const addServiceRequestUpdate = async (data: Comment): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/addServiceRequestUpdate`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const fetchAllServiceRequestUpdates = async (service_request_id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getServiceRequestUpdates?service_request_id=${service_request_id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const createAnnouncement = async (data: Announcements): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createAnnouncement`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const deleteAnnouncement = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/deleteAnnouncement`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });
    
    return response.json();
};

export const sendAnnouncementToUsers = async (announcementUserPairs: { announcement_id: string, user_ids:string[], sendSelection: SendAnnouncementOptions }): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/sendAnnouncementToUsers`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(announcementUserPairs)
    });
    
    return response.json();
};

export const readAnnouncement = async (announcementUserPair: { announcement_id: string, user_id: string }): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/readAnnouncement`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(announcementUserPair)
    });
    
    return response.json();
};

export const fetchAnnouncementById = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAnnouncementById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchAllAnnouncements = async (sortColumn: string, sortDirection: string, offset: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllAnnouncements?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchAllUnits = async (): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllUnits`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchUnitByUser = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getUnitByUserId?user_id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchOccupantsByUnitId = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getOccupantsByUnitId?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchUnitFile = async (id: number, fromDate: string, toDate: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getUnitFile?unit_id=${id}&from_date=${fromDate}&to_date=${toDate}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const holdBooking = async (data: HoldBooking): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/holdBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    return response.json();
}

export const deleteBookingHold = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/deleteBookingHold`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const confirmBooking = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/confirmBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const approveBooking = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/approveBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const rejectBooking = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/rejectBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const cancelBooking = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/cancelBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const createBooking = async (data: any): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const fetchAllBookings = async (offset: number, sortColumn: string, sortDirection: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllBookings?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchBookingById = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getBookingById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchBookingComments = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getBookingComments?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const createBookingComment = async (data: Comment): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createBookingComment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const deleteBookingComment = async (comment_id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/deleteBookingComment`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({comment_id})
    });
    
    return response.json();
};

export const updateBookingHold = async (data: {
    id: number,
    amenity_id: number;
    slots?: Date[];
    booking_start: Date;
    booking_end?: Date;
}): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateBookingHold`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
};

export const updateBooking = async (data: {
    id: number,
    amenity_id: number;
    slots?: Date[];
    booking_start: Date;
    booking_end?: Date;
}): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateBooking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    return response.json();
}

export const createVisitorParking = async (data: VisitorParkingRequest): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createVisitorParking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const fetchAllVisitorsParking = async (offset: number, sortColumn: string, sortDirection: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllVisitorParkings?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchVisitorParkingById = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getVisitorParkingById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const updateVisitorParking = async (data: VisitorParkingRequest): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateVisitorParking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
};

export const approveVisitorParking = async (data: {
    approval_date: Date,
    approved_by: number,
    id: number
}): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/approveVisitorParking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    return response.json();
}

export const statusUpdateVisitorParking = async (id: number, status: VisitorParkingRequestStatus): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/statusUpdateVisitorParking`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id, status})
    });

    return response.json();
}

export const createViolation = async (data: Violation): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createViolation`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const updateStatusViolation = async (id: number, status: ViolationStatus): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateStatusViolation`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id, status})
    });
    
    return response.json();
}

export const fetchAllViolations = async (offset: number, sortColumn: string, sortDirection: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllViolations?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchViolationById = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getViolationById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchViolationComments = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getViolationComments?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const createViolationComment = async (data: Comment): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createViolationComment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const deleteViolation = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/deleteViolation`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });
    
    return response.json();
};

export const updateViolation = async (data: Violation): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateViolation`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
};

export const fetchAllAmenities = async (offset: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllAmenitiesList?offset=${offset}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchBlockedSlots = async (amenity_id: number, start_date: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getBlockedSlots?amenity_id=${amenity_id}&start_date=${start_date}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchTaskById = async (id: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getTaskById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchAllTasks = async (sortColumn: string, sortDirection: string, offset: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllToDoList?offset=${offset}&sort_column=${sortColumn}&sort_direction=${sortDirection}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const createTask = async (data: ToDo): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createTask`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const updateTaskStatus = async (id: number, status: string): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateTaskStatus`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id, status})
    });
    
    return response.json();
}

export const createEvent = async (data: CalendarEvent): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/createEvent`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });
    
    return response.json();
}

export const editEvent = async (data: CalendarEvent): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/updateEvent`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(data)
    });

    return response.json();
}

export const deleteEvent = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/deleteEvent`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({id})
    });

    return response.json();
}

export const fetchEventById = async (id: number): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getEventById?id=${id}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}

export const fetchAllEvents = async (start_date: Date, end_date: Date): Promise<any> => {
    const token = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_SERVER_URL}/getAllEvents?start=${start_date}&end=${end_date}`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });

    return response.json();
}